import { t } from '../../../i18n/uiText';
import BfHomeInsightPanel from './BfHomeInsightPanel';
import { MODE_ORDER } from './homeInsightProgress';

const LINK_META = {
  simple: { label: () => t('homeInsightExplain') || 'Объяснение' },
  application: { label: () => t('application') },
};

/**
 * BfHomeSpot — стих дня; разбор открывается в этой же карточке.
 */
export default function BfHomeSpot({
  greeting,
  bookName,
  chapter,
  verse,
  versePreview,
  bookId,
  translation,
  loading,
  hasPassage,
  insightMode,
  onInsightModeChange,
  onOpenPassage,
  onOpenInsight,
}) {
  const refNums =
    chapter != null ? `${chapter}${verse != null && verse !== '' ? `:${verse}` : ''}` : '';

  const reference = hasPassage ? `${bookName} ${refNums}`.trim() : '';

  const handleCloseInsight = () => {
    onInsightModeChange?.(null);
  };

  const handleSwitchMode = (next) => {
    onInsightModeChange?.(next);
  };

  if (insightMode && hasPassage && bookId) {
    return (
      <section className="bf-home-spot bf-home-spot--insight bf-home-glass" aria-label={t('dailyVerse')}>
        <BfHomeInsightPanel
          mode={insightMode}
          reference={reference}
          bookId={bookId}
          chapter={chapter}
          verse={verse}
          translation={translation}
          onClose={handleCloseInsight}
          onGoToVerse={onOpenPassage}
          onSwitchMode={handleSwitchMode}
        />
      </section>
    );
  }

  return (
    <section className="bf-home-spot bf-home-glass" aria-label={t('dailyVerse')}>
      <header className="bf-home-spot__masthead">
        {greeting && <p className="bf-home-spot__greeting">{greeting}</p>}
        <p className="bf-home-spot__label">{t('dailyVerse')}</p>
      </header>

      <div className="bf-home-spot__ref-row">
        <button
          type="button"
          className="bf-home-spot__ref"
          onClick={onOpenPassage}
          aria-busy={loading}
        >
          {loading ? (
            <span className="bf-home-spot__ref-loading">…</span>
          ) : hasPassage ? (
            <span className="bf-home-spot__ref-lines">
              <span className="bf-home-spot__ref-book">{bookName}</span>
              {refNums && <span className="bf-home-spot__ref-nums">{refNums}</span>}
            </span>
          ) : (
            <span className="bf-home-spot__ref-placeholder">
              {t('dailyVerseLoading') || 'Загрузка стиха…'}
            </span>
          )}
        </button>
      </div>

      <div className="bf-home-spot__body">
        {versePreview && !loading && (
          <blockquote className="bf-home-spot__verse" cite={hasPassage ? refNums : undefined}>
            <p>
              <span className="bf-home-spot__verse-mark bf-home-spot__verse-mark--open" aria-hidden="true">
                {'\u201C'}
              </span>
              <span className="bf-home-spot__verse-text">{versePreview}</span>
              <span className="bf-home-spot__verse-mark bf-home-spot__verse-mark--close" aria-hidden="true">
                {'\u201D'}
              </span>
            </p>
          </blockquote>
        )}
      </div>

      {hasPassage && !loading && (
        <nav className="bf-home-spot__nav" aria-label="Толкование">
          <div className="bf-home-spot__link bf-home-spot__link--open">
            <button
              type="button"
              className="bf-home-spot__link-main"
              onClick={onOpenPassage}
            >
              <span className="bf-home-spot__link-text">
                {t('contextSearchGoToRef') || 'Открыть в Библии'}
              </span>
              <span className="bf-home-spot__link-chev" aria-hidden="true" />
            </button>
          </div>
          {MODE_ORDER.map((mode, index) => {
            const meta = LINK_META[mode];
            if (!meta) return null;
            return (
              <div
                key={mode}
                className={`bf-home-spot__link${index === 0 ? ' bf-home-spot__link--lead' : ''}`}
              >
                <button
                  type="button"
                  className="bf-home-spot__link-main"
                  onClick={() => onOpenInsight(mode)}
                >
                  <span className="bf-home-spot__link-text">{meta.label()}</span>
                  <span className="bf-home-spot__link-chev" aria-hidden="true" />
                </button>
              </div>
            );
          })}
        </nav>
      )}
    </section>
  );
}
